export interface StagingBannerProps {
  env: 'local' | 'staging' | 'production';
}

export function StagingBanner({ env }: StagingBannerProps) {
  if (env === 'production') return null;
  return (
    <div className="eb-stage" role="note">
      {env === 'staging' ? 'STAGING – test data' : 'LOCAL – test data'}
    </div>
  );
}
